import React, { Dispatch, SetStateAction } from 'react';

import { GeneralError } from 'const';

type ErrorsContextProps = {
  generalErrors: GeneralError[];
  setGeneralErrors: Dispatch<SetStateAction<GeneralError[]>>;
};

export const ErrorsContext = React.createContext<ErrorsContextProps | null>(null);

export const ErrorsContextProvider = ({
  children,
  generalErrors,
}: {
  children: React.ReactNode;
  generalErrors?: GeneralError[];
}) => {
  const [generalErrorsState, setGeneralErrors] = React.useState<GeneralError[]>([]);

  React.useEffect(() => {
    if (generalErrors !== undefined) {
      setGeneralErrors(generalErrors);
    }
  }, [generalErrors]);

  return (
    <ErrorsContext.Provider value={{ generalErrors: generalErrorsState, setGeneralErrors }}>
      {children}
    </ErrorsContext.Provider>
  );
};
